/**
 * Internal dependencies
 */
import './style.scss';

const Spinner = (): JSX.Element => {
	return <span className="wc-block-components-spinner" aria-hidden="true" />;
};

export default Spinner;
